export const LAYOUT_MENU_ITEM_IDS = {
  RentalManager: 9,
  ApartmentAdvertising: 10,
  RentalResources: 11,
};

export const LAYOUT_MENU_ITEMS = [
  {
    parent: 0,
    id: LAYOUT_MENU_ITEM_IDS.RentalManager,
    title: { rendered: 'Rental manager' },
    url: '/rental-manager/',
    path: '/rental-manager/',
  },
  {
    parent: LAYOUT_MENU_ITEM_IDS.RentalManager,
    id: 'price-my-rental',
    title: { rendered: 'Price my rental' },
    url: '/rental-manager/price-my-rental/',
    path: '/rental-manager/price-my-rental/',
  },
  {
    parent: LAYOUT_MENU_ITEM_IDS.RentalManager,
    id: 'listing',
    title: { rendered: 'Listing' },
    url: '/rental-manager/post-a-listing/',
    path: '/rental-manager/post-a-listing/',
  },
  {
    parent: LAYOUT_MENU_ITEM_IDS.RentalManager,
    id: 'applications',
    title: { rendered: 'Applications' },
    url: '/rental-manager/tenant-screening/',
    path: '/rental-manager/tenant-screening/',
  },
  {
    parent: LAYOUT_MENU_ITEM_IDS.RentalManager,
    id: 'leases',
    title: { rendered: 'Leases' },
    url: '/rental-manager/rental-lease-agreements/',
    path: '/rental-manager/rental-lease-agreements/',
  },
  {
    parent: LAYOUT_MENU_ITEM_IDS.RentalManager,
    id: 'payment',
    title: { rendered: 'Payment' },
    url: '/rental-manager/collect-rent-online/',
    path: '/rental-manager/collect-rent-online/',
  },
  {
    parent: 0,
    id: LAYOUT_MENU_ITEM_IDS.ApartmentAdvertising,
    title: { rendered: 'Apartment advertising' },
    url: '/rentals-network/rental-advertising/',
    path: '/rentals-network/rental-advertising/',
  },
  {
    parent: LAYOUT_MENU_ITEM_IDS.ApartmentAdvertising,
    id: 'subscription-based-ads',
    title: { rendered: 'Subscription based ads' },
    url: '/rentals-network/rent-connect/',
    path: '/rentals-network/rent-connect/',
  },
  {
    parent: LAYOUT_MENU_ITEM_IDS.ApartmentAdvertising,
    id: 'syndicate-listings',
    title: { rendered: 'Syndicate listings' },
    url: '/rentals-network/listing-feeds/',
    path: '/rentals-network/listing-feeds/',
  },
  {
    parent: 0,
    id: LAYOUT_MENU_ITEM_IDS.RentalResources,
    title: { rendered: 'Resources' },
    url: '/rentals-network/resources/',
    path: '/rentals-network/resources/',
  },
];
